var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitButtonImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.27618 0.562103C2.52671 -0.187368 1.31157 -0.187368 0.562104 0.562103C-0.187368 1.31157 -0.187368 2.52671 0.562103 3.27618L9.2865 12.0006L0.563259 20.7238C-0.186212 21.4733 -0.186212 22.6884 0.563259 23.4379C1.31273 24.1873 2.52786 24.1873 3.27733 23.4379L12.0006 14.7146L20.7238 23.4379C21.4733 24.1873 22.6884 24.1873 23.4379 23.4379C24.1874 22.6884 24.1874 21.4733 23.4379 20.7238L14.7146 12.0006L23.439 3.27618C24.1885 2.52671 24.1885 1.31157 23.439 0.562103C22.6896 -0.187368 21.4744 -0.187368 20.725 0.562103L12.0006 9.28649L3.27618 0.562103Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitButtonImage);
export default __webpack_public_path__ + "static/media/ExitButtonImage.47a89cfe111ce7938a653ba6eb1ff214.svg";
export { ForwardRef as ReactComponent };